module.exports = __webpack_public_path__ + "static/modelAccuracy-6f95a0dac9a6bb2527d0a680f743176b.png";